import * as Yup from "yup";
import React from "react";
import FormDefault from "../../components/Forms/FormDefault";
import { Request } from "../../hooks/Request";
import { validateType } from "../../utils/constant";
import { validateArray, validateStatus } from "../../utils/validate";
import { requestAuth } from "../../components/services/RequestService";
import { toast } from "react-toastify";
import {
  adjuntarDex,
  readDam,
  readDim,
  readParte,
} from "../../components/services/ReadFile";

const listFields = ["seguimientoDeArribo"];
export const FormArrivalTracking = (props) => {
  const { procedure } = props;
  const procedureId = procedure?.id || procedure?.procedureId;

  const { data, loading } = Request({
    urlApi: procedureId
      ? `/Procedure/${procedureId}/datasets?${listFields.map((field) => `fieldnames=${field}`).join("&")}`
      : null,
  });

  function dataFields(list) {
    let aux = {};
    list?.forEach((element) => {
      aux = {
        ...aux,
        [element.name]: element.validate
          ? validateType[element.type] || null
          : null,
      };
    });
    return aux;
  }
  function dataIntialValues(list) {
    let aux = {};
    list?.forEach((element) => {
      aux = {
        ...aux,
        [element.name]:
          (element.initial === "false" ? false : element.initial) || "",
      };
    });
    return aux;
  }

  async function handleCreateOption(value, dropdown) {
    await requestAuth("post", "/dropdown/option", {
      Name: value,
      DropdownListLabel: dropdown,
    });
  }

  async function submitDataset(values, resetForm, btnSecondary) {
    await requestAuth("post", "/dataset", values)
      .then(async () => {
        const listRead = values.filter((f) => f.type === "fileRead");
        if (listRead && listRead.length > 0) {
          await readDataProcedure(0, listRead, [], resetForm, btnSecondary);
        } else {
          // reload();
          // onClose();
          // resetForm();
          // if (btnSecondary) {
          //   await handleSendProcedure(procedure, reload);
          // }
          toast.success("Envio exitoso");
        }
      })
      .catch(() => {
        toast.error("Error en el envio");
      });
  }

  async function readDataProcedure(
    index,
    fields,
    result,
    resetForm,
    btnSecondary,
  ) {
    if (index < fields.length) {
      switch (fields[index].url) {
        case "adjuntarDim":
          await readDim(
            fields,
            index,
            procedure,
            result,
            async (indexRecibe, fieldsRecibe, resultRecibe) =>
              await readDataProcedure(
                indexRecibe,
                fieldsRecibe,
                resultRecibe,
                resetForm,
                btnSecondary,
              ),
          );
          break;
        case "dimRegularizada":
          await readDim(
            fields,
            index,
            procedure,
            result,
            async (indexRecibe, fieldsRecibe, resultRecibe) =>
              await readDataProcedure(
                indexRecibe,
                fieldsRecibe,
                resultRecibe,
                resetForm,
                btnSecondary,
              ),
          );
          break;
        case "adjuntarDex":
          await adjuntarDex(
            fields,
            index,
            procedure,
            result,
            async (indexRecibe, fieldsRecibe, resultRecibe) =>
              await readDataProcedure(
                indexRecibe,
                fieldsRecibe,
                resultRecibe,
                resetForm,
                btnSecondary,
              ),
          );
          break;
        case "documentoDam":
          await readDam(
            fields,
            index,
            procedure,
            result,
            async (indexRecibe, fieldsRecibe, resultRecibe) =>
              await readDataProcedure(
                indexRecibe,
                fieldsRecibe,
                resultRecibe,
                resetForm,
                btnSecondary,
              ),
          );
          break;
        case "parteDeRecepcion":
          await readParte(
            fields,
            index,
            procedure,
            result,
            async (indexRecibe, fieldsRecibe, resultRecibe) =>
              await readDataProcedure(
                indexRecibe,
                fieldsRecibe,
                resultRecibe,
                resetForm,
                btnSecondary,
              ),
          );
          break;
      }
    } else {
      const badResult = result.filter(
        (read) => !validateStatus(read.readStatus) && read.validate,
      );
      if (validateArray(badResult)) {
        // reload();
        // onClose();
        // resetForm();
        toast.error(badResult[0].readData);
      } else {
        // reload();
        // onClose();
        // resetForm();
        // if (btnSecondary) {
        //   handleSendProcedure(procedure, reload);
        // }
        toast.success("Envio exitoso");
      }
    }
  }

  async function onSubmit(values, resetForm, fields) {
    const result = await Promise.all(
      fields.map(async (element) => {
        if (element.type === "file" || element.type === "fileRead") {
          if (
            (values[element.name] === "" || values[element.name] === null) &&
            (element.initial === "" || element.initial === null)
          ) {
            return null;
          } else if (
            (values[element.name] !== "" && !element.initial) ||
            (values[element.name] !== "" &&
              values[element.name] !== element.initial)
          ) {
            let formData = new FormData();
            formData.append("Name", element.name);
            formData.append("File", values[element.name]);
            formData.append("originalName", values[element.name].name);
            formData.append("Status", "verified");
            formData.append("ProcedureId", procedureId);
            const fileContents = await requestAuth(
              "post",
              "/files",
              formData,
            ).then((res) => {
              return {
                Value: res.data.url,
                ProcedureId: procedureId,
                FieldId: element.id,
                FileId: res.data.id,
                name: element.name,
                url: element.url,
                type: element.type,
              };
            });
            return fileContents;
          } else {
            return {
              Value: element.initial,
              ProcedureId: procedureId,
              FieldId: element.id,
              name: element.name,
              url: element.url,
              type: element.type,
            };
          }
        } else if (element.type === "selectNewOption") {
          if (values[element.name + "_isNew"]) {
            await handleCreateOption(
              values[element.name] || values[element.name] === 0
                ? values[element.name]
                : "",
              element.url,
            );
          }
          return {
            Value:
              values[element.name] || values[element.name] === 0
                ? values[element.name]
                : "",
            ProcedureId: procedureId,
            FieldId: element.id,
            name: element.name,
            url: element.url,
            type: element.type,
          };
        } else {
          return {
            Value:
              values[element.name] || values[element.name] === 0
                ? values[element.name]
                : "",
            ProcedureId: procedureId,
            FieldId: element.id,
            name: element.name,
            url: element.url,
            type: element.type,
          };
        }
      }),
    );
    await submitDataset(
      result.filter((n) => n),
      resetForm,
      values.btnSecondary,
    );
  }

  if (!procedureId || !loading || !data) {
    return null;
  }

  return (
    <div className="">
      <FormDefault
        /* tittle="Formulario de cotización" */
        fields={data
          .sort((a, b) => {
            const indexA = listFields.indexOf(a.name);
            const indexB = listFields.indexOf(b.name);
            return indexA - indexB;
          })
          .map((value, index) => ({
            ...value,
            id: procedureId,
            fieldId: value.id,
            label: value.label,
            labelCustom: (
              <>
                <span className="text-green-600">{index + 1}.</span>{" "}
                {value.label}
              </>
            ),
            name: value.name,
            validate: value.validate,
            placeholder: "Complete el campo",
            type: value.type === "fileRead" ? "file" : value.type,
            typeInput: value.type === "fileRead" ? "file" : value.type,
            initial: value.initial ? value.initial : null,
            urlApi: value.url
              ? value.url.includes("/")
                ? value.url
                : `/Dropdown/${value.url}/options`
              : "",
            urlInitial: value.url,
            value: "name",
            labelOption: "name",
          }))}
        initialValues={dataIntialValues(data)}
        validationSchema={Yup.object().shape(dataFields(data))}
        // onSubmit={() => {
        //   handleOnSubmit();
        //   //   if (values.fieldId_isNew) {
        //   //     handleNewOption(values);
        //   //   } else {
        //   //     onSubmit(values);
        //   //   }
        // }}
        onSubmit={async (values, resetForm) =>
          await onSubmit(values, resetForm, data)
        }
        buttonName="Guardar"
      />
    </div>
  );
};
